import { useEffect } from "react";

// Browser tab titles follow ui-ux-standard rule 13: most specific segment first, site name last,
// joined by " | ". Never an incident's subject, message or reporter - that is customer-written
// content and can carry PII; an incident is identified by its ticket ref only.

export const SITE_NAME = "FeedbackHub Admin";
const SEPARATOR = " | ";

/** Joins segments most-specific-first and appends the site name. Blank segments are dropped. */
export function formatPageTitle(...segments: Array<string | null | undefined>): string {
  const parts = segments
    .map((segment) => segment?.trim())
    .filter((segment): segment is string => Boolean(segment));
  return [...parts, SITE_NAME].join(SEPARATOR);
}

/**
 * Sets document.title. Pass null to leave it to a child component: parent effects run after
 * child effects, so a parent that also set the title would overwrite the child's.
 */
export function useDocumentTitle(title: string | null): void {
  useEffect(() => {
    if (title !== null) document.title = title;
  }, [title]);
}
